<div class="expert-editor">
	<app-email-import-issues [issues]="issues" [images]="images"></app-email-import-issues>

	<div class="expert-body">
		<div class="sidebar">
			<app-substitution-fields [showVimeoOption]="true" [insertMode]="true" (fieldSelected)="insertField($event)"></app-substitution-fields>
		</div>
		<div class="code">
			<app-html-code-editor [value]="html" (valueChange)="onValueChange($event)" (pasted)="onPasted($event)" (fileOpened)="onFileOpened($event)" [minHeight]="'0px'"></app-html-code-editor>
		</div>
		<div class="preview">
			<app-email-preview-frame [html]="html" [(device)]="device"></app-email-preview-frame>
		</div>
	</div>

	<input #imageInput type="file" accept="image/*" hidden (change)="onImageFile($event)" />
</div>
